module.exports = __webpack_public_path__ + "img/top_300.8dafa866.png";